import Vue from 'vue'

export const wallet = Vue.observable({
  address: '',
  isLoggedIn: false,
  isLoggingIn: false,
  needsRef: false,
})
